import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';

// Not using React.StrictMode: its dev-only double mount races with the
// editor's fabric.js Canvas.dispose() (same as in AutoTemplated). StrictMode
// has no effect on production builds.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
